import React, { useState, useEffect } from "react";

import Post from "./Post";
import { db } from "../firebase";
import Loading from "./Loading";

const Posts = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [quote, setQuote] = useState({});

  useEffect(() => {
    fetch(
      "https://gist.githubusercontent.com/farhankk360/5d106fcc7c09e2624b1480ae777d73f3/raw/e3c6895ce42069f0ee7e991229064f167fe8ccdc/quotes.json"
    )
      .then(res => res.json())
      .then(data => {
        const rnd = Math.floor(Math.random() * 102);
        setQuote(data.quotes[rnd]);
      })
      .catch(e => console.log(e));
  }, []);

  useEffect(() => {
    //fetch the posts
    db.collection("posts")
      .orderBy("createdAt", "desc")
      .get()
      .then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, " => ", doc.data());
          setPosts(prevstate => [...prevstate, { id: doc.id, ...doc.data() }]);
          setLoading(false);
        });
      });
  }, []);

  return (
    <>
      <div className="quote">
        <quote>"{quote.quote}"</quote>
        <br />
        <author>-{quote.author}</author>
      </div>
      {loading && <Loading />}
      <div className="posts">
        {posts.map(post => (
          <Post post={post} key={post.id} />
        ))}
      </div>
    </>
  );
};

export default Posts;
